import axios from "axios";
import constants from "@/config/constants";

function initialState() {
    return {
        all: [],
        relationships: {
            'event': 'title',
        },
        loading: false
    }
}

const getters = {
    data: state => state.all,
    all: state => state.all,
    total:         state => state.all.length,
    loading:       state => state.loading,
    relationships: state => state.relationships
}

const actions = {
    fetchData({ commit, state }) {
        commit('setLoading', true)

        return axios.get(constants.API_URL + '/api/v1/event-halls')
            .then(response => {
                commit('setAll', response.data.data)
                return response;
            })
            .catch(error => {
                const message = error.response.data.message || error.message
                commit('setError', message)
                return error;
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    destroyData({ commit, state }, id) {
        commit('setLoading', true)
        return axios.delete(constants.API_URL + '/api/v1/event-halls/' + id)
            .then(response => {
                commit('setAll', state.all.filter((item) => {
                    return item.id != id
                }))

                return response;
            })
            .catch(error => {
                const message = error.response.data.message || error.message
                commit('setError', message)
                return error;
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    resetState({ commit }) {
        commit('resetState')
    }
}

const mutations = {
    setAll(state, items) {
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
